import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { shape, string, arrayOf, func } from 'prop-types';

import { LaundryBundleImage } from './laundry/LaundryBundleImage';
import { getBundleImage } from '../utils/product-utils';
import ProductPodLayout from './laundry/ProductPodLayout';
import { LaundryProductDetails } from './laundry/LaundryProductDetails';

export const CustomProductPod = ({
  product,
  onSwap
}) => {

  const { itemId, identifiers } = product || {};
  const { productLabel } = identifiers || {};

  const handleChange = (value) => {
    onSwap({
      currentItemId: itemId,
      newItemId: value
    });
  };

  return (
    <ProductPodLayout
      leftColumn={
        <LaundryBundleImage itemId={itemId} src={getBundleImage(product, 2)} alt={productLabel} />
      }
      rightColumn={
        <LaundryProductDetails product={product} onSwapVariant={handleChange} />
      }
    />
  );
};

CustomProductPod.displayName = 'CustomProductPod';

CustomProductPod.propTypes = {
  product: shape({
    itemId: string.isRequired,
    selectableVariants: arrayOf(shape({
      name: string.isRequired,
      value: string.isRequired
    })).isRequired,
    category: string.isRequired,
    pricing: shape({}).isRequired,
    reviews: shape({
      ratingsReviews: shape({
        averageRating: string,
        totalReviews: string
      })
    }).isRequired,
    identifiers: shape({
      productLabel: string,
      brandName: string
    }).isRequired
  }).isRequired,
  onSwap: func.isRequired
};

CustomProductPod.dataModel = extend(
  LaundryProductDetails
);
